var $a61375bbb065e4f1$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log('Hash commit: ', "5b1e88bead77f201eadb43e9edf3cb715f678595");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();


//# sourceMappingURL=storibox.a2885f92.js.map
